import React, { useState, useEffect, useMemo,useCallback } from 'react';
import { Button, TextInput, Switch, Col } from 'react-materialize';
import axios from 'axios';
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2';
import printJS from 'print-js';
import PedidoReprintView from './../modal-reporte/pedido-reprint';
import { ErpConnect as qad } from '../../../services';
import { MdAttachFile, MdClose,MdHistoryEdu } from 'react-icons/md';
import AsyncSelect from 'react-select/async';

const ymdLocal = (d = new Date()) =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Mexico_City', year:'numeric', month:'2-digit', day:'2-digit' })
    .format(d);


const parseYMDLocal = (s) => {
  if (!s) return null;
  const [y,m,d] = s.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 0, 0, 0, 0);
};
const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0,0,0,0);
const endOfDay   = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23,59,59,999);

const STATUS_ALIAS = {
  'aplicando pago': 'aplicando pago',
  aplicando: 'aplicando pago',
  aplicando_pago: 'aplicando pago',
  'aplicando-pago': 'aplicando pago',
  waiting_validation: 'aplicando pago',
  waiting: 'aplicando pago',
  validando: 'aplicando pago',
  applying_payment: 'aplicando pago',

  facturado: 'facturado',
  invoice_set: 'facturado',
  invoiced: 'facturado',
  billed: 'facturado',

  surtiendo: 'surtiendo',
  surtidor_asignado: 'surtiendo',
  asignado: 'surtiendo',

  surtido: 'surtido',
  listo: 'surtido',
  surtido_empacando: 'surtido',

  empacando: 'empacando',
  packing: 'empacando',

  enviado: 'enviado',
  shipped: 'enviado',

  entregado: 'entregado',
  delivered: 'entregado',
};
const canonicalStatus = (s) => {
  const k = String(s || '').trim().toLowerCase();
  return STATUS_ALIAS[k] || (k ? k : '');
};
const prettyStatus = (s) => {
  const c = canonicalStatus(s);
  if (!c) return '—';
  return c.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};
const StatusPill = ({ status }) => {
  const c = canonicalStatus(status);
  const base = {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    border: '1px solid',
  };
  let style = { ...base, background: '#eceff1', color: '#37474f', borderColor: '#b0bec5' };
  if (c === 'aplicando pago') style = { ...base, background: '#fff8e1', color: '#8d6e00', borderColor: '#f0e1a6' };
  if (c === 'facturado')      style = { ...base, background: '#e3f2fd', color: '#0d47a1', borderColor: '#90caf9' };
  if (c === 'surtiendo')      style = { ...base, background: '#e8f5e9', color: '#1b5e20', borderColor: '#a5d6a7' };
  if (c === 'surtido')        style = { ...base, background: '#ede7f6', color: '#4527a0', borderColor: '#b39ddb' };
  if (c === 'empacando')      style = { ...base, background: '#f3e5f5', color: '#6a1b9a', borderColor: '#ce93d8' };
  if (c === 'enviado')        style = { ...base, background: '#e0f7fa', color: '#006064', borderColor: '#80deea' };
  if (c === 'entregado')      style = { ...base, background: '#e8f5e9', color: '#2e7d32', borderColor: '#a5d6a7' };
  return <span style={style}>{prettyStatus(status)}</span>;
};

const getUserSite = (u) => {
  const raw =
    u?.site ??
    u?.siteId ??
    u?.site_id ??
    u?.branchSite ??
    u?.branch_site ??
    u?.storeSite ??
    u?.store_site ??
    JSON.parse(localStorage.getItem('user') || '{}')?.site ??
    JSON.parse(localStorage.getItem('user') || '{}')?.siteId ??
    JSON.parse(localStorage.getItem('user') || '{}')?.site_id ??
    '';

  const s = String(raw || '').trim();
  if (s === '3000' || s === '3100') return s;
  const up = s.toUpperCase();
  if (up === 'MTY') return '3000';
  if (up === 'CDMX') return '3100';
  return s;
};

const normalizeId = (v) => String(v || '').trim().toUpperCase();
const getErpSalesIdFromPedido = (p) =>
  normalizeId(
    p?.salesPersonId ??
    p?.salesPersonal ??
    p?.sales_person_id ??
    p?.salespersonId ??
    p?.salesperson_id ??
    ''
  );

const getUserSalesId = (u) =>
  normalizeId(
    u?.salesPersonId ??
    u?.sales_person_id ??
    u?.agentId ??
    u?.agent_id ??
    u?.idAgente ??
    ''
  );




const isGerencia = (u) =>
  ['001', '002'].includes(String(u?.departmentId || '').padStart(3, '0'));

const HELPER_ALLOW = Object.freeze({
  VDMO: new Set(['VDMO','VCAC','VCAV','VASG']), 
  VYAR: new Set(['VYAR','VRIS','VJUH','VFRC'])  
});

const canUserRegisterOrder = (order, user) => {
  const erpSpId  = getErpSalesIdFromPedido(order); 
  const userSpId = getUserSalesId(user);           
  if (!erpSpId || !userSpId) return false;
  if (isGerencia(user)) return true;
  if (erpSpId === userSpId) return true;
  const allowed = HELPER_ALLOW[erpSpId];
  if (allowed && allowed.has(userSpId)) return true;

  return false;
};

const pickRemision = (o) =>
  String(
    o?.remisionId ??
    o?.remissionId ??
    o?.remision ??
    ''
  ).trim();

const hasRemissionERP = async (erpId) => {
  try {
    const r = await qad.catalog.salesOrder.findById(String(erpId).trim());
    return !!pickRemision(r);
  } catch {
    return false;
  }
};


const ModalRemoteOrders = ({ open, onClose, user, catalog }) => {
  const [loadingGuardar, setLoadingGuardar] = useState(false);
  const [erpOrderId, setErpOrderId] = useState('');
  const [files, setFiles] = useState({ vouchers: [], invoice: null });
  const [pedidoInfo, setPedidoInfo] = useState(null);
  const [selectedCajera, setSelectedCajera] = useState(null);
  const [loadingPedido, setLoadingPedido] = useState(false);
  const [selectedCarrier, setSelectedCarrier] = useState(null);
  const [createdOrders, setCreatedOrders] = useState([]);
  const [loadingPreviewSaved, setLoadingPreviewSaved] = useState(false);
  const [savingMsg, setSavingMsg] = useState('');
  const [savingPct, setSavingPct] = useState(null);
  const [saldoAFavor, setSaldoAFavor] = useState(false);
  const [payOnDelivery, setPayOnDelivery] = useState(false);
  const [invoiceRequired, setInvoiceRequired] = useState(false);
  const [selectedRegimen, setSelectedRegimen] = useState(null);
  const [selectedCfdi, setSelectedCfdi] = useState(null);
  const [consolidateOrders, setConsolidateOrders] = useState(false);
  const [extraErpIdInput, setExtraErpIdInput] = useState('');
  const [extraErpIds, setExtraErpIds] = useState([]);
  const [clientePasa, setClientePasa] = useState(false);

  const [advisorComment, setAdvisorComment] = useState('');

  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewData, setPreviewData] = useState(null);

  const [refreshing, setRefreshing] = useState(false);

  const [voucherPreviews, setVoucherPreviews] = useState([]);

  const userSite = useMemo(() => getUserSite(user), [user]);
  const [carrierCajera, setCarrierCajera] = useState(null);
  const [carrierCajeraInput, setCarrierCajeraInput] = useState('');
 



  ///AGregado
  const fetchCajeraByCarrier = useCallback(async (carrierName) => {
    if (!carrierName) {
        setCarrierCajera(null);
        setCarrierCajeraInput('');
        return;
    }

    try {
       
        const encodedCarrier = encodeURIComponent(carrierName);
        const response = await axios.get(`/api/carriers/${encodedCarrier}/cajera`, {
            params: { site: userSite },
          
            timeout: 5000
        });
        
        if (response.data) {
            setCarrierCajera(response.data);
            setCarrierCajeraInput(response.data.label);
            
            if (!selectedCajera) {
                setSelectedCajera(response.data);
            }
        } else {
            setCarrierCajera(null);
            setCarrierCajeraInput('No hay cajera asignada por defecto');
        }
    } catch (error) {
        console.error('[FETCH_CAJERA_ERROR]', error);
      
        setCarrierCajeraInput('Error al cargar cajera asignada');
       
        if (error.response?.status === 404) {
            console.log('Ruta de carriers no encontrada - verificar backend');
        }
    }
}, [userSite, selectedCajera]);
  console.log(savingMsg);
  console.log(savingPct);

  useEffect(() => {
    if (!Array.isArray(files?.vouchers) || files.vouchers.length === 0) {
      setVoucherPreviews(prev => {
        prev.forEach(p => URL.revokeObjectURL(p.url));
        return [];
      });
      return;
    }
    const next = files.vouchers.map(f => ({
      url: URL.createObjectURL(f),
      type: f.type || '',
      name: f.name || 'archivo',
      size: f.size || 0,
    }));
    setVoucherPreviews(prev => {
      prev.forEach(p => URL.revokeObjectURL(p.url));
      return next;
    });
    return () => {
      next.forEach(p => URL.revokeObjectURL(p.url));
    };
  }, [files.vouchers]);
  const fetchCreatedOrders = useCallback(async () => {
    try {
      const u = JSON.parse(localStorage.getItem('user') || '{}');
      const site = getUserSite(user);
  
      const res = await axios.get(
        `/api/remote-orders/created-by?created_by=${encodeURIComponent(u?.username || '')}&site=${encodeURIComponent(site)}`,
        { headers: { 'x-site': site } }
      );
  
      if (Array.isArray(res.data)) setCreatedOrders(res.data);
    } catch (error) {
      console.error('Error al cargar turnos creados:', error);
    }
  }, [user]); 
  const doRefresh = async () => {
    setRefreshing(true);
    try { await fetchCreatedOrders(); } finally { setRefreshing(false); }
  };

  const buildTabsFromItems = (items = []) => {
    const have = new Set();
    const tabs = [];
    items.forEach((it, idx) => {
      const id = String(it.erp || '');
      if (!id) return;
      have.add(id);
      tabs.push({ id, label: idx === 0 ? `Principal — ${id}` : id, srcIdx: idx, kind: 'erp' });
    });
    items.forEach((it) => {
      const orig = String(it.erp_original || '');
      if (!orig || orig === String(it.erp || '')) return;
      if (!have.has(orig)) {
        have.add(orig);
        tabs.push({ id: orig, label: `Original — ${orig}`, srcIdx: null, kind: 'orig' });
      }
    });
    return tabs;
  };

  const findItemForTab = (items = [], tabId) =>
    items.find(x => String(x.erp) === String(tabId)) ||
    items.find(x => String(x.erp_original || '') === String(tabId)) || null;

  const canShowPOD = useMemo(() => {
    const name = (selectedCajera?.label || '').trim().toLowerCase();
    return name === 'devany perez' || name === 'devany salazar';
  }, [selectedCajera]);

  useEffect(() => {
    if (!canShowPOD && payOnDelivery) {
      setPayOnDelivery(false);
      setFiles(prev => ({ ...prev, vouchers: [] }));
    }
  }, [canShowPOD, payOnDelivery]);

  const esc = (v) =>
    String(v ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes spin { 0%{transform:rotate(0)} 100%{transform:rotate(360deg)} }
      .spinner { border:6px solid #ccc; border-top:6px solid #1976d2; border-radius:50%; width:40px; height:40px; animation:spin 1s linear infinite; margin-right:15px; }
      .loading-container { display:flex; align-items:center; font-size:1.5rem; font-weight:bold; color:#1976d2; }
      .swal2-container { z-index: 9999999 !important; }
      .preview-card { border:1px solid #cfe3ff; background:#f7fbff; border-radius:10px; padding:12px; margin-top:10px; }
      .preview-table { width:100%; border-collapse:collapse; margin-top:8px }
      .preview-table th, .preview-table td { border-bottom:1px solid #e3eefc; padding:6px 8px; font-size: 13px; }
      .pill { display:inline-block; padding:2px 8px; border-radius:999px; background:#e3f2fd; border:1px solid #90caf9; font-size:12px; margin-right:6px }
      .preview-scroll { max-height: 260px; overflow-y: auto; border:1px solid #e3eefc; border-radius: 8px; }
      .ptab-btn{border:1px solid #90caf9;background:#e3f2fd;border-radius:999px;padding:4px 10px;font-size:13px;font-weight:600;cursor:pointer}
      .ptab-btn.active{background:#bbdefb}
      .progress-wrap{width:320px;max-width:80vw}
.progress-label{display:flex;justify-content:space-between;font-size:12px;color:#444;margin-bottom:6px}
.progress-bar{height:10px;border-radius:999px;background:#e0e0e0;overflow:hidden}
.progress-fill{height:100%;width:0%;background:#1976d2;transition:width .25s ease}
.btn-busy{opacity:.6;pointer-events:none}

    `;
    document.head.appendChild(style);
  }, []);

  const [filterFrom, setFilterFrom] = useState(() => ymdLocal(new Date()));
  const [filterTo, setFilterTo] = useState(() => ymdLocal(new Date()));

  useEffect(() => {
    if (open) {
      setPedidoInfo(null);
      setErpOrderId('');
      setFiles({ vouchers: [], invoice: null });
      setSelectedCajera(null);
      setSelectedCarrier(null);
      setSaldoAFavor(false);
      setPayOnDelivery(false);
      setInvoiceRequired(false);
      setSelectedRegimen(null);
      setSelectedCfdi(null);
      setConsolidateOrders(false);
      setExtraErpIdInput('');
      setExtraErpIds([]);
      setFilterFrom(ymdLocal(new Date()));
      setFilterTo(ymdLocal(new Date()));
      setPreviewData(null);
      fetchCreatedOrders();
    }
  }, [open,fetchCreatedOrders]);

  const getItemCode = (d = {}) =>
    d.item || d.itemId || d.productId || d.code || '';

  const getItemName = (d = {}) =>
    d.description || d.product || d.itemName || d.productName || d.desc || d.name || d.text || '';

  const PreviewTabs = ({ items = [], originals = {} }) => {
    const tabs = useMemo(() => buildTabsFromItems(items), [items]);
    const [active, setActive] = useState(() => tabs[0]?.id);
    useEffect(() => {
      const firstTabId = tabs[0]?.id;
    
      setActive(firstTabId);
    }, [tabs]);  

    const lookup = (tabId) =>
      originals[tabId] || findItemForTab(items, tabId) || {};

    const it = lookup(active);
    const money = (n) => Number(n||0).toFixed(2);

    return (
      <div className="preview-card">
        <div style={{ marginTop: 4, fontWeight: 700, fontSize: '1.1rem' }}>
          Detalle por pedido
        </div>

        <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginTop:8 }}>
          {tabs.map(t => (
            <button
              key={t.id}
              className={'ptab-btn' + (String(active) === String(t.id) ? ' active' : '')}
              onClick={() => setActive(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div style={{ fontSize: '1rem', fontWeight: 700, color: '#222', marginTop: 6 }}>
          {it.header?.customer && <div><b>Cliente:</b> {it.header.customer}</div>}
          {it.header?.salesperson && <div><b>Vendedor:</b> {it.header.salesperson}</div>}
          <div style={{ marginTop: 4 }}>
            <span><b>Cant:</b> {Number(it.quantity || 0)}</span> ·
            <span><b> Subtotal:</b> ${money(it.subtotal)}</span> ·
            <span><b> IVA:</b> ${money(it.iva)}</span> ·
            <span><b> Total:</b> ${money(it.total)}</span>
          </div>
        </div>

        {Array.isArray(it.detail) && it.detail.length > 0 && (
          <div className="preview-scroll">
            <table className="preview-table">
              <thead>
                <tr>
                  <th>Artículo</th>
                  <th>Descripción</th>
                  <th style={{ textAlign: 'right' }}>Cant</th>
                  <th style={{ textAlign: 'right' }}>Precio</th>
                  <th style={{ textAlign: 'right' }}>Importe</th>
                </tr>
              </thead>
              <tbody>
                {it.detail.map((d, k) => {
                  const qty   = Number(d.qtyOrd || 0);
                  const price = Number(d.price || d.unitPrice || 0);
                  const amt   = Number(d.amount || (qty * price));
                  return (
                    <tr key={k}>
                      <td>{getItemCode(d)}</td>
                      <td>{getItemName(d)}</td>
                      <td style={{ textAlign: 'right' }}>{qty}</td>
                      <td style={{ textAlign: 'right' }}>${price.toFixed(2)}</td>
                      <td style={{ textAlign: 'right' }}>${amt.toFixed(2)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  const eliminarTurno = async (id) => {
    const confirm = await Swal.fire({
      title: '¿Eliminar turno?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });
    if (!confirm.isConfirmed) return;

    try {
      const res = await axios.delete(`/api/remote-orders/${id}`);
      if (res.data.success) {
        Swal.fire('Turno eliminado', '', 'success');
        fetchCreatedOrders();
      } else {
        throw new Error('No se eliminó correctamente');
      }
    } catch (error) {
      console.error('Error al eliminar turno:', error);
      Swal.fire('Error', 'No se pudo eliminar el turno', 'error');
    }
  };

  const setQuickRange = (type) => {
    const today = new Date();

    if (type === 'hoy') {
      setFilterFrom(ymdLocal(today)); setFilterTo(ymdLocal(today)); return;
    }
    if (type === 'ayer') {
      const y = new Date(today); y.setDate(y.getDate() - 1);
      setFilterFrom(ymdLocal(y)); setFilterTo(ymdLocal(y)); return;
    }
    if (type === '7') {
      const s = new Date(today); s.setDate(s.getDate() - 6);
      setFilterFrom(ymdLocal(s)); setFilterTo(ymdLocal(today)); return;
    }
    if (type === 'mes') {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      setFilterFrom(ymdLocal(first)); setFilterTo(ymdLocal(last)); return;
    }
    if (type === 'clear') {
      setFilterFrom(''); setFilterTo(''); return;
    }
  };

  const getEffectiveDate = (o) => new Date(o?.returned_at || o.created_at);

  const filteredOrders = useMemo(() => {
    if (!Array.isArray(createdOrders)) return [];

    const byErp = createdOrders.reduce((acc, o) => {
      const key = o.erp_order_id || `id:${o.id}`;
      const prev = acc[key];
      if (!prev || getEffectiveDate(o) > getEffectiveDate(prev)) {
        acc[key] = o;
      }
      return acc;
    }, {});
    let list = Object.values(byErp);

    const f = parseYMDLocal(filterFrom);
    const t = parseYMDLocal(filterTo);

    if (f) {
      const sf = startOfDay(f).getTime();
      list = list.filter((o) => getEffectiveDate(o).getTime() >= sf);
    }
    if (t) {
      const et = endOfDay(t).getTime();
      list = list.filter((o) => getEffectiveDate(o).getTime() <= et);
    }

    return list.sort((a, b) => getEffectiveDate(b) - getEffectiveDate(a));
  }, [createdOrders, filterFrom, filterTo]);

  const getCajeraValue = (a) =>
    normalizeId(
      a?.salesPersonId ?? 
      a?.id ??           
      a?.agent ??        
      a?.username ?? ''
    );
  
  const getCajeraLabel = (a) =>
    String(
      a?.name ??
      a?.fullName ??
      a?.displayName ??
      a?.username ??
      a?.agent ??
      ''
    ).trim();
  
  const getAnySite = (a) =>
    String(a?.site ?? a?.siteId ?? a?.site_id ?? '').trim();
  
  const getAnyDept = (a) =>
    String(a?.departmentId ?? a?.deptId ?? a?.department_id ?? '').trim();
  
  const getAnyDeptName = (a) =>
    String(a?.deparmentName ?? a?.departmentName ?? '').trim().toUpperCase();
  
  const isCajeraRow = (a) => {
    const dep = String(getAnyDept(a) || '').padStart(3, '0');
    const depName = getAnyDeptName(a);
    return dep === '004' || depName === 'CAJERA';
  };
  
 
  const loadCajeras = (inputValue = '', tipoEntrega = '') => {

    const q = (inputValue || '').toLowerCase();
  
    const sources =
      (Array.isArray(catalog?.users) && catalog.users) ||
      (Array.isArray(catalog?.posUsers) && catalog.posUsers) ||
      (Array.isArray(catalog?.agents) && catalog.agents) ||
      [];
  
    let list = sources;
  
    
    if (String(userSite) === '3100') {
  
      const bySite = list.filter(a => getAnySite(a) === '3100');
      const cajeras = bySite.filter(isCajeraRow);
      list = (cajeras.length ? cajeras : bySite);
  
      if (!list.length) {
        list = [
          {
            name: 'Elizabeth Carranza',
            salesPersonId: 'VECA',
            agent: 'ecarranz',
            site: '3100',
            departmentId: '004',
            deparmentName: 'CAJERA'
          }
        ];
      }
  
      list = list.slice(0, 2);
  
    } else {
      const idsPermitidos = ['VNAH','VDEP','VDES','VYIS'];
      list = list.filter(a => idsPermitidos.includes(getCajeraValue(a)));
    }
  
    const filtradas = list
      .filter(a => getCajeraLabel(a).toLowerCase().includes(q))
      .map(a => ({ label: getCajeraLabel(a), value: getCajeraValue(a) }))
      .filter(x => !!x.label && !!x.value);
  
    return Promise.resolve(filtradas);
  };
  console.log(loadCajeras)
  const loadCarriers = async (inputValue = '') => {
    const q = (inputValue || '').toLowerCase();
    
    try {
        // Intentar cargar desde el backend primero
        const response = await axios.get('/api/carriers');
        if (Array.isArray(response.data)) {
            return response.data
                .filter(c => c.name.toLowerCase().includes(q))
                .map(c => ({ label: c.name, value: c.name }));
        }
    } catch (error) {
        console.log('[CARRIERS_BACKEND_ERROR]', error);
        // Fallback a la lista hardcodeada si el backend falla
    }
    
    // Fallback a la lista original
    const carriers = (String(userSite) === '3100')
        ? ['Cliente-pasa']
        : ['Pmm', 'Estafeta', 'Saltillo', 'Domicilio','Cliente_pasa','Paquete_express', 'Dhl', 'Inbox',
           'Spatmail', 'Tres_guerras', 'Paqmex', 'Teammex', 'FedEx', 'Flecha_Amarilla'];
    
    return carriers
        .filter(c => c.toLowerCase().includes(q))
        .map(c => ({ label: c, value: c }));
};

  
  const loadRegimenOptions = (inputValue = '') => {
    const all = [
      '601 - General de Ley Personas Morales',
      '603 - Personas Morales con Fines no Lucrativos',
      '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios',
      '606 - Arrendamiento',
      '608 - Demás ingresos',
      '609 - Consolidación',
      '610 - Residentes en el Extranjero sin Establecimiento Permanente en México',
      '611 - Ingresos por Dividendos (socios y accionistas)',
      '612 - Personas Físicas con Actividades Empresariales y Profesionales',
      '614 - Ingresos por intereses',
      '615 - Régimen de los ingresos por obtención de premios',
      '616 - Sin obligaciones fiscales',
      '620 - Sociedades Cooperativas de Producción',
      '621 - Incorporación Fiscal',
      '622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
      '623 - Opcional para Grupos de Sociedades',
      '624 - Coordinados',
      '626 - Régimen Simplificado de Confianza',
      '625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
      '628 - Hidrocarburos',
      '629 - De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales',
      '630 - Enajenación de acciones en bolsa de valores'

    ];
    return Promise.resolve(
      all
        .filter(x => x.toLowerCase().includes((inputValue || '').toLowerCase()))
        .map(x => ({ label: x, value: x }))
    );
  };
  
  const loadCfdiOptions = (inputValue = '') => {
    const all = [
      'G01 - Adquisición de mercancías',
      'G03 - Gastos en general',
      'S01 - Sin efectos fiscales',
    ];
    return Promise.resolve(
      all
        .filter(x => x.toLowerCase().includes((inputValue || '').toLowerCase()))
        .map(x => ({ label: x, value: x }))
    );
  };
  
  const swalAlert = (title, icon = 'warning', text = '') => {
    Swal.fire({
      title,
      text,
      icon,
      didOpen: () => {
        const s = Swal.getPopup();
        if (s) s.style.zIndex = 9999999;
      }
    });
  };

  const abrirModalComentario = async () => {
    const { value: text } = await Swal.fire({
      title: 'Comentario para Cajas',
      input: 'textarea',
      inputLabel: 'Este comentario se mostrará en Cajas',
      inputValue: advisorComment,
      inputPlaceholder: 'Escribe aquí indicaciones, notas, etc.',
      inputAttributes: { maxlength: 500, 'aria-label': 'Comentario' },
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar'
    });
    if (text !== undefined) setAdvisorComment((text || '').trim());
  };

  const buscarPedido = async (arg) => {
    const idOverride = (typeof arg === 'string' || typeof arg === 'number') ? String(arg) : undefined;
  
    const folio = (idOverride ?? erpOrderId)?.toString().trim();
    if (!folio) return;
  
    setLoadingPedido(true);
    try {
      const result = await qad.catalog.salesOrder.findById(folio);
      if (!result) {
        swalAlert('Pedido no encontrado');
        return;
      }
  
      const agentCodeFromName = (name) => {
        try {
          const list = Array.isArray(catalog?.agents) ? catalog.agents : [];
          const a = list.find(
            x => String(x.name || '').trim().toLowerCase() === String(name || '').trim().toLowerCase()
          );
          return a?.id || '';
        } catch { return ''; }
      };
  
      const erpSalesId =
        result.salesPersonId ||
        result.salesPersonal ||
        result.sales_person_id ||
        result.salespersonId ||
        result.salesperson_id ||
        agentCodeFromName(result.salesPerson) || '';
  
      const pedidoTemp = {
        cliente: result.customer,
        agente: result.salesPerson,
        remision: result.remisionId,
        status: result.status,
        articulos: result.detail,
        direccion: result.address,
        comentarios: result.remarks,
        fecha: result.orderDate,
        total: result.total,
        subtotal: result.subTotal,
        descuento: result.discount,
        iva: result.IVA,
        invoice_id: result.invoiceId || null,
        salesPersonId: erpSalesId
      };
  
      const esValido = canUserRegisterOrder(pedidoTemp, user);
  
      if (!esValido) {
        await Swal.fire({
          icon: 'error',
          title: 'Este pedido NO te corresponde',
          html: `
            <div style="text-align:left">
              <b>Pedido ERP</b><br/>
              • Vendedor: <b>${pedidoTemp.agente || '—'}</b><br/>
              <b>Tu sesión</b><br/>
              • Usuario: <b>${user.name || '—'}</b><br/>
            </div>
            <br/>
            El turno sólo puede ser registrado por el agente propietario del pedido.
          `,
          confirmButtonText: 'Entendido'
        });
        setPedidoInfo(null);
        return;
      }
  
      const sinRemision = !pedidoTemp.remision || pedidoTemp.remision.trim() === '';
      const avisoRemision = sinRemision
        ? `<br/><b style="color:#d9534f">⚠️ Este pedido no tiene remisión registrada.</b><br/>Deberás crearla antes de guardar el turno.`
        : '';
  
      await Swal.fire({
        icon: 'success',
        title: 'Pedido válido para tu usuario',
        html: `
          <div style="text-align:left">
            <b>Pedido:</b> ${folio}<br/>
            <b>Cliente:</b> ${pedidoTemp.cliente}<br/>
            <b>Vendedor:</b> ${pedidoTemp.agente}<br/>
            <b>Remisión:</b> ${pedidoTemp.remision || '<i>Sin remisión</i>'}<br/>
          </div>
          ${avisoRemision}
          <br/>Puedes continuar con el registro del turno.
        `,
        confirmButtonText: 'Continuar'
      });
  
      setPedidoInfo(pedidoTemp);
      setErpOrderId(folio);
      setPreviewData(null);
    } catch (error) {
      console.error('[ERROR_PEDIDO]', error);
      swalAlert('Error', 'error', 'No se pudo consultar el pedido');
    } finally {
      setLoadingPedido(false);
    }
  };
      

const renderVoucherThumb = (url, name = '') => {
  const lower = (url || '').toLowerCase();
  const isImg = /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/.test(lower);
  const isPdf = /\.pdf(\?|$)/.test(lower);

  if (isImg) {
    return `
      <div class="vcard">
        <div class="vthumb">
          <img src="${url}" alt="${esc(name)}" style="max-width:100%;max-height:100%;object-fit:cover" />
        </div>
        <div class="vrow">
          <a class="vlink" href="${url}" target="_blank" rel="noopener">Abrir</a>
        </div>
      </div>
    `;
  }
  if (isPdf) {
    return `
      <div class="vcard">
        <div class="vthumb" style="font-size:12px;display:flex;align-items:center;justify-content:center">PDF</div>
        <div class="vrow">
          <a class="vlink" href="${url}" target="_blank" rel="noopener">Ver PDF</a>
        </div>
      </div>
    `;
  }
  return `
    <div class="vcard">
      <div class="vthumb" style="font-size:12px;display:flex;align-items:center;justify-content:center">Archivo</div>
      <div class="vrow">
        <a class="vlink" href="${url}" target="_blank" rel="noopener">Descargar</a>
      </div>
    </div>
  `;
};

const verDevolucion = async (orderRow) => {
  const makeFileUrl = (relativePath = '') => {
    if (!relativePath) return '';
    if (/^https?:\/\//i.test(relativePath)) return relativePath; 
    const clean = String(relativePath).replace(/^\/+/, '');
    const { protocol, hostname } = window.location;
    const base = `${protocol}//${hostname}:3001`; 
    return `${base}/${clean}`;
  };

  try {
    const { data } = await axios.get(`/api/foraneos/${orderRow.id}`);
    if (!data?.success) {
      Swal.fire('Error', 'No se pudo cargar el detalle', 'error');
      return;
    }

    const it = data.item || {};

    const styles = `
      <style>
        .gridv { display:grid; grid-template-columns: repeat(auto-fill, minmax(140px,1fr)); gap:10px; margin-top:8px }
        .vcard { border:1px solid #e0e0e0; border-radius:8px; background:#fff; overflow:hidden }
        .vthumb { height:110px; background:#fafafa; border-bottom:1px dashed #ddd; }
        .vrow { padding:8px; display:flex; justify-content:center }
        .vlink { font-weight:700; color:#1565c0; text-decoration:none }
        .box { border:1px solid #e8eef7; background:#f7fbff; border-radius:8px; padding:8px; }
        .muted { color:#666; font-size:12px }
        .kv { display:grid; grid-template-columns: 120px 1fr; gap:6px; }
        .kv b { color:#333 }
      </style>
    `;

    const vouchers =
      (it.voucher_files || [])
        .map((u) => renderVoucherThumb(makeFileUrl(u), u))
        .join('') ||
      '<div class="muted">Sin comprobantes.</div>';

    const commentHtml = it.return_reason
      ? `<div class="box" style="white-space:pre-wrap">${esc(it.return_reason)}</div>`
      : '<div class="muted">Sin comentario de devolución.</div>';

    Swal.fire({
      title: `Devuelto · ${esc(it.erp_order_id || '')}`,
      width: 900,
      html: `
        ${styles}
        <div class="kv" style="margin-bottom:10px">
          <div><b>Cliente:</b></div><div>${esc(it.customer_name || '')}</div>
          <div><b>Paquetería:</b></div><div>${esc(it.carrier || '—')}</div>
          <div><b>Estatus:</b></div><div>${esc(it.status || '')}</div>
          <div><b>Creado:</b></div><div>${new Date(it.created_at).toLocaleString('es-MX')}</div>
          ${it.returned_at ? `<div><b>Devuelto:</b></div><div>${new Date(it.returned_at).toLocaleString('es-MX')}</div>` : ''}
          ${it.assigned_to_name ? `<div><b>Cajera:</b></div><div>${esc(it.assigned_to_name)}</div>` : ''}
          ${it.sales_person ? `<div><b>Vendedor:</b></div><div>${esc(it.sales_person)}</div>` : ''}
        </div>

        <div style="margin-top:10px">
          <div style="font-weight:800;margin-bottom:6px">Comentario de devolución</div>
          ${commentHtml}
        </div>

        <div style="margin-top:14px">
          <div style="font-weight:800;margin-bottom:6px">Comprobantes</div>
          <div class="gridv">${vouchers}</div>
        </div>
      `,
      showCancelButton: true,
      cancelButtonText: 'Cerrar',
      confirmButtonText: 'Ver pedido(s)',
      confirmButtonColor: '#0ea5e9'
    }).then((res) => {
      if (res.isConfirmed) {
        previewSavedOrder(orderRow);
      }
    });
  } catch (e) {
    console.error('[verDevolucion]', e);
    Swal.fire('Error', 'No se pudo mostrar el detalle', 'error');
  }
};

  const mostrarLinkSeguimiento = async (id) => {
    try {
      const { data } = await axios.get(`/api/remote-orders/${id}/public-link`);
      if (!data.success || !data.public_url) {
        return Swal.fire('Sin enlace', 'Este pedido aún no tiene enlace público.', 'info');
      }

      const ord = createdOrders.find((o) => o.id === id) || {};
      const public_url = data.public_url;
      const customer_name = data.customer_name ?? ord.customer_name ?? '—';
      const erp_order_id_local = data.erp_order_id ?? ord.erp_order_id ?? '—';

      Swal.fire({
        title: 'Enlace de seguimiento',
        html: `
          <div style="text-align:left">
            <p><b>Cliente:</b> ${esc(customer_name)}</p>
            <p><b>Pedido:</b> ${esc(erp_order_id_local)}</p>
            <input class="swal2-input"
                   style="margin:0;width:100%"
                   value="${esc(public_url)}"
                   readonly>
            <div style="display:flex;gap:8px;margin-top:8px">
              <a class="swal2-confirm swal2-styled"
                 href="${esc(public_url)}"
                 target="_blank"
                 rel="noopener"
                 style="margin:0;text-decoration:none;line-height:2.2">Abrir</a>
            </div>
          </div>
        `,
        showConfirmButton: false
      });
    } catch (e) {
      console.error(e);
      Swal.fire('Error', 'No se pudo obtener el enlace', 'error');
    }
  };

  const regenerarLinkSeguimiento = async (id) => {
    const ok = await Swal.fire({
      title: 'Rotar enlace público',
      text: 'Se invalidará el enlace anterior y se creará uno nuevo.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Rotar'
    });
    if (!ok.isConfirmed) return;

    try {
      const { data } = await axios.put(`/api/remote-orders/${id}/public-link`);
      if (!data.success) throw new Error('No success');

      const ord = createdOrders.find((o) => o.id === id) || {};
      const public_url = data.public_url;
      const customer_name = data.customer_name ?? ord.customer_name ?? '—';
      const erp_order_id_local = data.erp_order_id ?? ord.erp_order_id ?? '—';

      Swal.fire({
        title: 'Nuevo enlace',
        html: `
          <div style="text-align:left">
            <p><b>Cliente:</b> ${esc(customer_name)}</p>
            <p><b>Pedido:</b> ${esc(erp_order_id_local)}</p>
            <input class="swal2-input"
                   style="margin:0;width:100%"
                   value="${esc(public_url)}"
                   readonly>
            <div style="display:flex;gap:8px;margin-top:8px">
              <a class="swal2-confirm swal2-styled"
                 href="${esc(public_url)}"
                 target="_blank"
                 rel="noopener"
                 style="margin:0;text-decoration:none;line-height:2.2">Abrir</a>
            </div>
          </div>
        `,
        showConfirmButton: false
      });
    } catch (e) {
      console.error(e);
      Swal.fire('Error', 'No se pudo rotar el enlace', 'error');
    }
  };

  const prefillFromOrder = async (order) => {
    setErpOrderId(order.erp_order_id || '');
    setSelectedCajera(
      order.assigned_to
        ? { value: order.assigned_to, label: order.assigned_to_name || order.assigned_to }
        : null
    );
    setSelectedCarrier(order.carrier ? { value: order.carrier, label: order.carrier } : null);
    setSaldoAFavor(Number(order.has_credit_note) === 1);
    setPayOnDelivery(Number(order.pay_on_delivery) === 1);
    setInvoiceRequired(Number(order.invoice_required) === 1);
    setSelectedRegimen(order.tax_regimen ? { value: order.tax_regimen, label: order.tax_regimen } : null);
    setSelectedCfdi(order.cfdi_use ? { value: order.cfdi_use, label: order.cfdi_use } : null);
    setAdvisorComment(order.advisor_comment || '');
    setFiles({ vouchers: [], invoice: null });
    setConsolidateOrders(false);
    setExtraErpIds([]);
    setPreviewData(null);
  
    window.scrollTo({ top: 0, behavior: 'smooth' });
  
    Swal.fire({
      icon: 'info',
      title: 'Turno cargado para edición',
      text: order.return_reason ? `Motivo de devolución: ${order.return_reason}` : 'Ajusta datos y vuelve a enviar.',
      timer: 1800,
      showConfirmButton: false
    });
  
    await buscarPedido(order.erp_order_id);
  };
  
  const buildPreviewConsolidated = async () => {
    if (!pedidoInfo) return Swal.fire('Primero busca un pedido válido', '', 'info');
    if (!consolidateOrders || extraErpIds.length === 0) {
      return Swal.fire('Agrega pedidos ERP para consolidar', '', 'info');
    }
    setPreviewLoading(true);
    try {
      const items = [];
      const originalIds = new Set(); 
  
      const pushItem = (id, r) => {
        const qty = Array.isArray(r?.detail)
          ? r.detail.reduce((n, d) => n + (Number(d.qtyOrd) || 0), 0)
          : 0;
  
        const orig = String(r.erp_order_id_original || '').trim();
        if (orig && orig !== String(id)) originalIds.add(orig);
  
        items.push({
          erp: id,
          erp_original: r.erp_order_id_original || null,
          header: {
            customer: r.customer,
            address: r.address,
            salesperson: r.salesPerson,
            rfc: r.rfc,
            remarks: r.remarks
          },
          detail: r.detail || [],
          subtotal: Number(r.subTotal || 0),
          iva: Number(r.IVA || 0),
          total: Number(r.total || 0),
          quantity: qty
        });
      };
  
      pushItem(erpOrderId, {
        customer: pedidoInfo.cliente,
        address: pedidoInfo.direccion,
        salesPerson: pedidoInfo.agente,
        rfc: '',
        remarks: pedidoInfo.comentarios,
        detail: pedidoInfo.articulos,
        subTotal: pedidoInfo.subtotal,
        IVA: pedidoInfo.iva,
        total: pedidoInfo.total
      });
  
      for (const id of extraErpIds) {
        try {
          const r = await qad.catalog.salesOrder.findById(id.trim());
          if (r) pushItem(id.trim(), r);
          else items.push({ erp:id.trim(), header:{}, detail:[], subtotal:0, iva:0, total:0, quantity:0, error:'No encontrado' });
        } catch (e) {
          console.error('[PREVIEW_EXTRA_ERROR]', id, e);
          items.push({ erp:id.trim(), header:{}, detail:[], subtotal:0, iva:0, total:0, quantity:0, error:'Error al consultar' });
        }
      }
  
      const originals = {};
      for (const oid of originalIds) {
        try {
          const r = await qad.catalog.salesOrder.findById(oid);
          if (!r) continue;
          const qty = Array.isArray(r?.detail)
            ? r.detail.reduce((n, d) => n + (Number(d.qtyOrd) || 0), 0)
            : 0;
          originals[oid] = {
            erp: oid,
            erp_original: null,
            header: {
              customer: r.customer,
              address: r.address,
              salesperson: r.salesPerson,
              rfc: r.rfc,
              remarks: r.remarks
            },
            detail: r.detail || [],
            subtotal: Number(r.subTotal || 0),
            iva: Number(r.IVA || 0),
            total: Number(r.total || 0),
            quantity: qty,
            isOriginal: true
          };
        } catch {}
      }
  
      const totals = items.reduce((acc, it) => {
        acc.subtotal += Number(it.subtotal || 0);
        acc.iva      += Number(it.iva || 0);
        acc.total    += Number(it.total || 0);
        acc.quantity += Number(it.quantity || 0);
        return acc;
      }, { subtotal: 0, iva: 0, total: 0, quantity: 0 });
  
      setPreviewData({ items, totals, originals });
    } finally {
      setPreviewLoading(false);
    }
  };
  
  const renderPreviewHtml = ({ items  }) => {
    const pillsHtml = buildTabsFromItems(items).map(t =>
      `<button class="swbtn" data-id="${esc(t.id)}">${esc(t.label)}</button>`
    ).join('');
  
    return `
      <style>
        .swbtn{border:1px solid #90caf9;background:#e3f2fd;border-radius:999px;padding:4px 10px;font-size:13px;font-weight:600;cursor:pointer;margin:0 6px 6px 0}
        .swbtn.active{background:#bbdefb}
      </style>
      <div class="preview-card">
        <div style="margin-top:4px;font-weight:700">Detalle por pedido</div>
        <div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:8px">${pillsHtml}</div>
        <div id="sw-tabs-content" style="margin-top:10px"></div>
      </div>
    `;
  };

  const previewVoucherAt = (idx) => {
    const p = voucherPreviews[idx];
    if (!p) return;
    const isImg = (p.type || '').startsWith('image/');
    const isPdf = (p.type || '') === 'application/pdf';

    if (isImg) {
      Swal.fire({
        title: p.name,
        html: `<img src="${p.url}" alt="${esc(p.name)}" style="max-width:100%;max-height:70vh;border-radius:8px;border:1px solid #e0e0e0" />`,
        width: Math.min(window.innerWidth - 80, 900),
        showConfirmButton: true,
        confirmButtonText: 'Cerrar',
      });
      return;
    }

    if (isPdf) {
      Swal.fire({
        title: p.name,
        html: `
          <div style="height:70vh">
            <iframe src="${p.url},#view=FitH" style="width:100%;height:100%;border:0;border-radius:8px"></iframe>
          </div>
        `,
        width: Math.min(window.innerWidth - 80, 1000),
        showConfirmButton: true,
        confirmButtonText: 'Cerrar',
      });
      return;
    }

    Swal.fire({
      title: p.name,
      text: 'Tipo de archivo no previsualizable. ¿Abrir en nueva pestaña?',
      showCancelButton: true,
      confirmButtonText: 'Abrir',
      cancelButtonText: 'Cancelar'
    }).then(res => {
      if (res.isConfirmed) window.open(p.url, '_blank', 'noopener');
    });
  };

  const previewSavedOrder = async (orderRow) => {
    setLoadingPreviewSaved(true);
    try {
      const mainErp = String(orderRow?.erp_order_id || '').trim();
      if (!mainErp) {
        Swal.fire('Sin Pedido ERP', 'No se encontró el folio ERP del turno.', 'info');
        return;
      }

      let extraIds = [];
      const origMap = new Map(); 
      try {
        const { data } = await axios.get(`/api/remote-orders/${orderRow.id}/groups`);
        if (data?.success && Array.isArray(data.items)) {
          extraIds = data.items
            .map(x => String(x.erp_order_id || '').trim())
            .filter(Boolean);

          data.items.forEach(x => {
            const erp = String(x.erp_order_id || '').trim();
            const orig = String(x.erp_order_id_original || '').trim();
            if (erp && orig) origMap.set(erp, orig);
          });
        }
      } catch (e) {
        console.warn('[REMOTE_ORDER_GROUPS]', e?.message || e);
      }

      const mainForcedOriginal = String(
        orderRow.erp_order_id_original || orderRow.erp_order_id_prev || ''
      ).trim();
      if (mainForcedOriginal && mainForcedOriginal !== mainErp) {
        origMap.set(mainErp, mainForcedOriginal);
      }

      const uniq = (arr) => Array.from(new Set(arr));
      const idsToFetch = uniq([mainErp, ...extraIds]).filter(id => !!id);

      const items = [];
      const originalIds = new Set(); 

      const pushItem = (id, r) => {
        const qty = Array.isArray(r?.detail)
          ? r.detail.reduce((n, d) => n + (Number(d.qtyOrd) || 0), 0)
          : 0;

        const erpOriginal =
          String(r.erp_order_id_original || '').trim() ||
          String(origMap.get(id) || '').trim() || null;

        if (erpOriginal && erpOriginal !== String(id)) {
          originalIds.add(erpOriginal);
        }

        items.push({
          erp: id,
          erp_original: erpOriginal,
          header: {
            customer: r.customer,
            address: r.address,
            salesperson: r.salesPerson,
            rfc: r.rfc,
            remarks: r.remarks
          },
          detail: r.detail || [],
          subtotal: Number(r.subTotal || 0),
          iva: Number(r.IVA || 0),
          total: Number(r.total || 0),
          quantity: qty
        });
      };

      for (const id of idsToFetch) {
        try {
          const r = await qad.catalog.salesOrder.findById(id);
          if (r) {
            const forced = origMap.get(id);
            if (forced) r.erp_order_id_original = forced;
            pushItem(id, r);
          } else {
            items.push({
              erp: id,
              erp_original: null,
              header: {},
              detail: [],
              subtotal: 0,
              iva: 0,
              total: 0,
              quantity: 0,
              error: 'No encontrado'
            });
          }
        } catch (e) {
          console.error('[PREVIEW_FETCH_ERROR]', id, e);
          items.push({
            erp: id,
            erp_original: null,
            header: {},
            detail: [],
            subtotal: 0,
            iva: 0,
            total: 0,
            quantity: 0,
            error: 'Error al consultar'
          });
        }
      }

      const originals = {};
      for (const oid of originalIds) {
        try {
          const r = await qad.catalog.salesOrder.findById(oid);
          if (!r) continue;
          const qty = Array.isArray(r?.detail)
            ? r.detail.reduce((n, d) => n + (Number(d.qtyOrd) || 0), 0)
            : 0;
          originals[oid] = {
            erp: oid,
            erp_original: null,
            header: {
              customer: r.customer,
              address: r.address,
              salesperson: r.salesPerson,
              rfc: r.rfc,
              remarks: r.remarks
            },
            detail: r.detail || [],
            subtotal: Number(r.subTotal || 0),
            iva: Number(r.IVA || 0),
            total: Number(r.total || 0),
            quantity: qty,
            isOriginal: true
          };
        } catch (e) {
          console.warn('[PREVIEW_ORIGINAL_FETCH_ERROR]', oid, e);
        }
      }

      const totals = items.reduce(
        (acc, it) => {
          acc.subtotal += Number(it.subtotal || 0);
          acc.iva += Number(it.iva || 0);
          acc.total += Number(it.total || 0);
          acc.quantity += Number(it.quantity || 0);
          return acc;
        },
        { subtotal: 0, iva: 0, total: 0, quantity: 0 }
      );

      const onPopupOpen = (popup) => {
        if (!popup) return;
        const tabs = buildTabsFromItems(items); 
        const money = (n) => Number(n || 0).toFixed(2);

        const content = popup.querySelector('#sw-tabs-content');
        if (!content) return;

        const btns = Array.from(popup.querySelectorAll('.swbtn'));

        const lookup = (activeId) =>
          originals[activeId] ||
          items.find((x) => String(x.erp) === String(activeId)) ||
          items.find((x) => String(x.erp_original || '') === String(activeId)) ||
          {};
        
        const render = (activeId) => {
          const it = lookup(activeId);
          const rows = Array.isArray(it.detail)
            ? it.detail
                .map((d) => {
                  const qty = Number(d.qtyOrd || 0);
                  const price = Number(d.price || d.unitPrice || 0);
                  const amt = Number(d.amount || qty * price);
                  return `
                    <tr>
                      <td>${esc(getItemCode(d))}</td>
                      <td>${esc(getItemName(d))}</td>
                      <td style="text-align:right">${qty}</td>
                      <td style="text-align:right">$${money(price)}</td>
                      <td style="text-align:right">$${money(amt)}</td>
                    </tr>
                  `;
                })
                .join('')
            : '';

          content.innerHTML = `
            <div style="font-weight:700;font-size:1rem;margin-bottom:6px">
              ${
                it.header && it.header.customer
                  ? `<b>Cliente:</b> ${esc(it.header.customer)} · `
                  : ''
              }
              ${
                it.header && it.header.salesperson
                  ? `<b>Vendedor:</b> ${esc(it.header.salesperson)} · `
                  : ''
              }
              <b>Cant:</b> ${Number(it.quantity || 0)}
              · <b>Subtotal:</b> $${money(it.subtotal)}
              · <b>IVA:</b> $${money(it.iva)}
              · <b>Total:</b> $${money(it.total)}
            </div>
            ${
              rows
                ? `
              <div class="preview-scroll">
                <table class="preview-table">
                  <thead>
                    <tr>
                      <th>Artículo</th>
                      <th>Descripción</th>
                      <th style="text-align:right">Cant</th>
                      <th style="text-align:right">Precio</th>
                      <th style="text-align:right">Importe</th>
                    </tr>
                  </thead>
                  <tbody>${rows}</tbody>
                </table>
              </div>`
                : `<div class="p-2" style="color:#666">No hay partidas para este pedido.</div>`
            }
          `;

          btns.forEach((b) => {
            if (b.dataset.id === String(activeId)) b.classList.add('active');
            else b.classList.remove('active');
          });
        };

        btns.forEach((b) => b.addEventListener('click', () => render(b.dataset.id)));
        if (tabs[0]) render(tabs[0].id);
      };

      Swal.fire({
        title: `Pedido(s) de ${orderRow.customer_name || ''}`,
        html: renderPreviewHtml({ items, totals }),
        width: 900,
        showConfirmButton: true,
        confirmButtonText: 'Cerrar',
        onOpen: onPopupOpen,  
        didOpen: onPopupOpen  
      });
    } catch (e) {
      console.error('[previewSavedOrder]', e);
      Swal.fire('Error', 'No se pudo armar la previsualización.', 'error');
    } finally {
      setLoadingPreviewSaved(false);
    }
  };
  
  const handleSubmit = async () => {
    if (!pedidoInfo || !selectedCajera || !selectedCarrier) {
      return Swal.fire({
        title: !pedidoInfo
          ? 'Primero busca un pedido válido'
          : !selectedCajera
            ? 'Debes seleccionar una cajera'
            : 'Debes seleccionar una paquetería',
        icon: 'warning',
        backdrop: true,
        customClass: { popup: 'swal-z-index' }
      });
    }
  
    if (!pedidoInfo.remision) {
      const r = await Swal.fire({
        icon: 'warning',
        title: 'Este pedido no tiene Remisión',
        html: 'Para continuar debes crear la remisión.',
        showDenyButton: true,
        denyButtonText: 'Crear Remisión',
        confirmButtonText: 'Cerrar'
      });
      if (r.isDenied) {
        // aquí podrías abrir el ERP si aplica
      }
      return;
    }
  
    if (!canUserRegisterOrder(pedidoInfo, user)) {
      await Swal.fire({
        icon: 'error',
        title: 'No puedes guardar este turno',
        html: `
          <div style="text-align:left">
            <b>Pedido ERP</b><br/>
            • Vendedor: <b>${pedidoInfo?.agente || '—'}</b><br/><br/>
            <b>Tu sesión</b><br/>
            • salesPersonId: <b>${getUserSalesId(user) || '—'}</b>
          </div>
          <br/>El turno sólo puede ser registrado por el agente propietario del pedido.
        `,
      });
      return;
    }
  
    const mustRequireVoucher = !(saldoAFavor || payOnDelivery);
    if (mustRequireVoucher && (!files.vouchers || files.vouchers.length === 0)) {
      return Swal.fire('Falta comprobante', 'Adjunta al menos un comprobante de pago o marca crédito/POD.', 'warning');
    }
  
    if (invoiceRequired && (!selectedRegimen || !selectedCfdi)) {
      return Swal.fire('Faltan datos de factura', 'Selecciona Régimen y Uso CFDI.', 'warning');
    }
  
    if (consolidateOrders && extraErpIds.length === 0) {
      return Swal.fire('Faltan pedidos', 'Agrega al menos un Pedido ERP adicional para consolidar.', 'warning');
    }
  
    if (consolidateOrders && extraErpIds.length > 0) {
      setSavingMsg('Validando remisiones de pedidos agregados…');
      setSavingPct(null);
      setLoadingGuardar(true);
  
      const faltantes = [];
      try {
        const checks = await Promise.allSettled(extraErpIds.map(id => hasRemissionERP(id)));
        checks.forEach((res, i) => {
          const ok = res.status === 'fulfilled' && res.value === true;
          if (!ok) faltantes.push(extraErpIds[i]);
        });
      } catch {
        faltantes.push('Verificar pedidos agregados');
      }
  
      if (faltantes.length > 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Pedidos sin remisión',
          html: `
            <div style="text-align:left">
              Los siguientes pedidos agregados NO tienen remisión:
              <ul style="margin-top:8px">
                ${faltantes.map(f => `<li><b>${esc(f)}</b></li>`).join('')}
              </ul>
              Debes registrar la remisión en el ERP y volver a intentar.
            </div>
          `,
          confirmButtonText: 'Entendido'
        });
        setLoadingGuardar(false);
        setSavingMsg('');
        setSavingPct(null);
        return;
      }
    }
  
    setSavingMsg('Preparando archivos y datos…');
    setSavingPct(null);
    setLoadingGuardar(true);
  
    const u = JSON.parse(localStorage.getItem('user') || '{}');
  
    // ✅ Usa el site real 3000/3100 (del user actual)
    const site = getUserSite(user) || getUserSite(u);
  
    const formData = new FormData();
    formData.append('site', site);
  
    formData.append('customer_name', pedidoInfo.cliente);
    formData.append('erp_order_id', erpOrderId);
    formData.append('created_by', u?.username || u?.name || 'unknown');
    formData.append('assigned_to', selectedCajera.value);
    formData.append('assigned_to_name', selectedCajera.label);
    formData.append('sales_person', pedidoInfo.agente || '');
    formData.append('remision', pedidoInfo.remision || '');
    formData.append('order_status', pedidoInfo.status || 'Abierto');
    formData.append('carrier', selectedCarrier.value);
    formData.append('has_credit_note', saldoAFavor ? 1 : 0);
    formData.append('pay_on_delivery', (canShowPOD && payOnDelivery) ? 1 : 0);
    formData.append('invoice_required', invoiceRequired ? 1 : 0);
    formData.append('tax_regimen', selectedRegimen?.value || '');
    formData.append('cfdi_use', selectedCfdi?.value || '');
    formData.append('consolidate_orders', consolidateOrders ? 1 : 0);
    (extraErpIds || []).forEach(id => formData.append('erp_order_ids[]', id));
    formData.append('invoice_id', pedidoInfo.invoice_id || '');
    formData.append('advisor_comment', advisorComment || '');
  
    const carrierValue = String(selectedCarrier?.value ?? '').trim().toUpperCase();
    const isPickup = Boolean(clientePasa) || carrierValue === 'LOCAL';
  
    // ✅ FIX: pickup_branch SIEMPRE debe ser el site (3000/3100) para filtrar correctamente
    formData.append('pickup_branch', site);
  
    // (Opcional) si quieres conservar “sucursal/branch” real cuando es pickup, mándalo en otro campo
    const pickupStore = isPickup
      ? (user?.branch || user?.branchId || user?.sucursal || user?.store || '')
      : '';
    formData.append('pickup_store', pickupStore);
  
    formData.append('delivery_mode', isPickup ? 'pickup' : 'carrier');
    formData.append('isPickup', isPickup ? 'true' : 'false');
  
    if (mustRequireVoucher && Array.isArray(files.vouchers)) {
      files.vouchers.forEach((file) => formData.append('voucher', file));
    }
  
    try {
      setSavingMsg('Enviando turno al servidor…');
  
      const res = await axios.post('/api/remote-orders', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-site': site,
        },
        onUploadProgress: (e) => {
          if (e?.total) {
            const pct = Math.round((e.loaded / e.total) * 100);
            setSavingPct(pct);
            setSavingMsg(pct >= 100 ? 'Procesando en servidor…' : 'Subiendo comprobantes…');
          }
        }
      });
  
      if (res.data.success) {
        setSavingMsg('Finalizando…');
  
        const { public_url } = res.data;
        setErpOrderId('');
        setFiles({ vouchers: [], invoice: null });
        setPedidoInfo(null);
        setSelectedCajera(null);
        setSelectedCarrier(null);
        setSaldoAFavor(false);
        setPayOnDelivery(false);
        setInvoiceRequired(false);
        setSelectedRegimen(null);
        setSelectedCfdi(null);
        setConsolidateOrders(false);
        setExtraErpIdInput('');
        setExtraErpIds([]);
        setAdvisorComment('');
        setPreviewData(null);
        fetchCreatedOrders();
  
        await Swal.fire({
          title: 'Turno guardado correctamente',
          html: `
            <div style="text-align:left">
              <p style="margin-bottom:6px">Comparte el enlace de seguimiento:</p>
              <input class="swal2-input" style="margin:0;width:100%" value="${esc(public_url)}" readonly>
              <div style="margin-top:10px;display:flex;gap:8px;justify-content:flex-start">
                <a href="${esc(public_url)}" target="_blank" rel="noopener"
                   class="swal2-styled"
                   style="
                     margin:0;
                     text-decoration:none;
                     line-height:2.2;
                     display:inline-block;
                     width:auto !important;
                     padding:.625em 1.1em;
                     font-size:1em;
                   ">
                  Abrir seguimiento
                </a>
              </div>
            </div>
          `,
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        });
      }
    } catch (error) {
      console.error('Error al guardar el turno:', error);
      Swal.fire({ title: 'Error', text: 'No se pudo guardar el turno', icon: 'error', backdrop: true });
    } finally {
      setLoadingGuardar(false);
      setSavingMsg('');
      setSavingPct(null);
    }
  };
  
          
  const printPedido = () => {
    printJS({ printable: 'reprintContainer', type: 'html', targetStyles: ['*'] });
  };

  if (!open) return null;

  return ReactDOM.createPortal(
    (
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999999 }}>
        <div style={{ backgroundColor: 'white', width: '100vw', height: '100vh', overflowY: 'auto', padding: '2rem', border: '3px solid #2196f3' }}>
          <h5>Pedidos Foráneos</h5>
  
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '1rem' }}>
            <TextInput label="Pedido ERP" value={erpOrderId} onChange={(e) => setErpOrderId(e.target.value)} />
            <Button onClick={() => buscarPedido()}>BUSCAR PEDIDO</Button>
          </div>
  
          <Button
            onClick={onClose}
            className="red"
            style={{ position: 'absolute', top: '10px', right: '20px', zIndex: 9999, borderRadius: '50%', padding: '8px', minWidth: 'unset', width: '60px', height: '60px' }}
            title="Cerrar ventana"
          >
            <MdClose size={20} color="white" />
          </Button>
  
          {loadingPedido && (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(255, 255, 255, 0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999999 }}>
              <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1976d2' }}>Cargando pedido...</div>
            </div>
          )}
  
          {loadingGuardar && (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(255, 255, 255, 0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999999 }}>
              <div className="loading-container">
                <div className="spinner"></div>
                Guardando turno...
              </div>
            </div>
          )}
  
          {loadingPreviewSaved && (
            <div style={{
              position: 'fixed',
              top: 0, left: 0, width: '100vw', height: '100vh',
              backgroundColor: 'rgba(255, 255, 255, 0.6)',
              display: 'flex', justifyContent: 'center', alignItems: 'center',
              zIndex: 9999999
            }}>
              <div className="loading-container">
                <div className="spinner"></div>
                Cargando pedidos
              </div>
            </div>
          )}
  
  {pedidoInfo && (
  <div
    style={{
      display: 'flex',
      gap: '2rem',
      alignItems: 'flex-start',
      marginTop: '2rem',
      maxWidth: '100%',
      overflowX: 'auto'
    }}
  >
    <div
      style={{
        flex: '0 0 400px',
        maxWidth: '400px',
        padding: '1.5rem',
        border: '1px solid #ccc',
        borderRadius: '10px',
        backgroundColor: '#f9f9f9'
      }}
    >
      <h6 style={{ marginBottom: '1rem', fontWeight: 'bold' }}>Datos del pedido</h6>
      <p><strong>Cliente:</strong> {pedidoInfo.cliente}</p>
      <p><strong>Agente:</strong> {pedidoInfo.agente}</p>
      <p><strong>Remisión:</strong> {pedidoInfo.remision}</p>
      <p><strong>Estado:</strong> {pedidoInfo.status}</p>

      <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
        <Button onClick={printPedido}>  <span role="img" aria-label="imprimir">🖨️</span>Imprimir Pedido</Button>
        <Button onClick={handleSubmit}><span role="img" aria-label="Guardar">💾 </span> Guardar Turno</Button>
      </div>

      <div style={{ marginTop: '1rem' }}>
        <Button onClick={abrirModalComentario}>  <span role="img" aria-label="Comentario">📝</span>Comentario para Cajas</Button>
        {advisorComment && (
          <div style={{ marginTop: '8px', background: '#fff', border: '1px dashed #90caf9', borderRadius: 8, padding: '8px 10px', fontSize: 13 }}>
            <strong>Comentario:</strong>
            <div style={{ whiteSpace: 'pre-wrap' }}>{advisorComment}</div>
          </div>
        )}
      </div>

  
      <div>
        <h6 style={{ marginTop: '1rem', fontWeight: 'bold' }}>Asignar Paquetería</h6>
        <AsyncSelect
          placeholder="Selecciona paquetería"
          isClearable
          cacheOptions
          defaultOptions
          loadOptions={loadCarriers}
            onChange={(value) => {
                setSelectedCarrier(value);
                fetchCajeraByCarrier(value?.value);
                
                const norm = String(value?.value || '').trim().toUpperCase();
                if (norm !== 'Cliente_pasa') setClientePasa(false);
                
                setSelectedCajera(null);
            }}
            value={selectedCarrier}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999999 }) }}
        />
     {selectedCarrier && (
    <div style={{ 
        marginTop: '1rem', 
        padding: '12px',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        background: '#f8f9fa'
    }}>
        <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontWeight: 600, color: '#495057' }}>
                 Cajera asignada a {selectedCarrier.label}
            </span>
            {carrierCajera && (
                <span style={{
                    background: '#e3f2fd',
                    color: '#0d47a1',
                    padding: '2px 8px',
                    borderRadius: '16px',
                    fontSize: '11px',
                    fontWeight: 600
                }}>
                    Por defecto
                </span>
            )}
        </div>
        
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {/* Campo de solo lectura */}
            <input
                type="text"
                value={carrierCajeraInput || (selectedCajera?.label || 'Selecciona una cajera')}
                readOnly
                style={{
                    flex: 1,
                    padding: '10px 12px',
                    border: '1px solid #ced4da',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: '#fff',
                    color: '#495057',
                    cursor: 'default'
                }}
            />
            
            
        </div>
        
      
    </div>
)}
      </div>
    </div>

    <div style={{ flex: '1 1 auto', minWidth: 420, maxWidth: '900px' }}>
    {String(selectedCarrier?.value || '').trim().toUpperCase() === 'LOCAL' && (
  <Col className="p-bottom s4 l3" style={{ marginTop: 12 }}>
    <label>Cliente pasa</label>
    <Switch
      id="clientePasa"
      onLabel="Sí"
      offLabel="No"
      checked={clientePasa}
      onChange={(e) => setClientePasa(e.target.checked)}
    />
  </Col>
)}

      <Col className="p-bottom s4 l3">
        <label>¿Cliente con crédito?</label>
        <Switch
          id="saldoAFavor"
          onLabel={'Si'}
          offLabel={'No'}
          checked={saldoAFavor}
          onChange={(e) => {
            const on = e.target.checked;
            setSaldoAFavor(on);
            if (on) setFiles((prev) => ({ ...prev, vouchers: [] }));
          }}
        />
      </Col>

      {canShowPOD && (
        <Col className="p-bottom s4 l3" style={{ marginTop: 12 }}>
          <label>Pago contra entrega</label>
          <Switch
            id="payOnDelivery"
            onLabel={'Si'}
            offLabel={'No'}
            checked={payOnDelivery}
            onChange={(e) => {
              const on = e.target.checked;
              setPayOnDelivery(on);
              if (on) setFiles((prev) => ({ ...prev, vouchers: [] }));
            }}
          />
        </Col>
      )}

      <Col className="p-bottom s4 l3" style={{ marginTop: 12 }}>
        <label>Ocupa factura</label>
        <Switch
          id="invoiceRequired"
          onLabel={'Si'}
          offLabel={'No'}
          checked={invoiceRequired}
          onChange={(e) => {
            const on = e.target.checked;
            setInvoiceRequired(on);
            if (!on) {
              setSelectedRegimen(null);
              setSelectedCfdi(null);
            }
          }}
        />
      </Col>

      {invoiceRequired && (
        <div style={{ marginTop: 10, maxWidth: 520 }}>
          <div style={{ marginBottom: 10 }}>
            <label style={{ display:'block', marginBottom: 4, fontSize: 12, color:'#666' }}>Régimen</label>
            <AsyncSelect
              placeholder="Selecciona régimen"
              isClearable
              cacheOptions
              defaultOptions
              loadOptions={loadRegimenOptions}
              onChange={(v) => setSelectedRegimen(v)}
              value={selectedRegimen}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999999 }) }}
            />
          </div>

          <div>
            <label style={{ display:'block', marginBottom: 4, fontSize: 12, color:'#666' }}>Uso CFDI</label>
            <AsyncSelect
              placeholder="Selecciona uso CFDI"
              isClearable
              cacheOptions
              defaultOptions
              loadOptions={loadCfdiOptions}
              onChange={(v) => setSelectedCfdi(v)}
              value={selectedCfdi}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999999 }) }}
            />
          </div>
        </div>
      )}

      <Col className="p-bottom s4 l3" style={{ marginTop: 12 }}>
        <label>Consolidar o agregar pedidos</label>
        <Switch
          id="consolidateOrders"
          onLabel={'Si'}
          offLabel={'No'}
          checked={consolidateOrders}
          onChange={(e) => {
            const on = e.target.checked;
            setConsolidateOrders(on);
            if (!on) {
              setExtraErpIds([]);
              setExtraErpIdInput('');
              setPreviewData(null);
            }
          }}
        />
      </Col>                  {consolidateOrders && (
                    <div style={{ marginTop: 8, maxWidth: 520 }}>
                      <div style={{ display:'flex', gap:8, alignItems:'flex-end', flexWrap:'wrap' }}>
                        <div style={{ flex: '1 1 240px' }}>
                          <TextInput
                            label="Agregar otro Pedido ERP"
                            placeholder="Ej. P250671"
                            value={extraErpIdInput}
                            onChange={(e) => setExtraErpIdInput(e.target.value)}
                          />
                        </div>
                        <Button
                          small
                          onClick={() => {
                            const v = (extraErpIdInput || '').trim();
                            if (!v) return;
                            const all = new Set([erpOrderId.trim(), ...extraErpIds.map(x => x.trim())]);
                            if (all.has(v)) { setExtraErpIdInput(''); return; }
                            setExtraErpIds(prev => [...prev, v]);
                            setExtraErpIdInput('');
                            setPreviewData(null);
                          }}
                          style={{ minWidth:'unset' }}
                        >
                          + Agregar
                        </Button>
                        <Button
                          small
                          className="grey"
                          onClick={() => {
                            Swal.fire({
                              title: 'Pegar varios Pedidos ERP',
                              input: 'textarea',
                              inputPlaceholder: 'P250671, P250672\nP250673 ...',
                              showCancelButton: true,
                              confirmButtonText: 'Agregar'
                            }).then(({ value }) => {
                              if (!value) return;
                              const tokens = value
                                .split(/[\s,;\n]+/)
                                .map(s => s.trim())
                                .filter(Boolean);
                              if (tokens.length === 0) return;
                              const base = new Set([erpOrderId.trim(), ...extraErpIds.map(x => x.trim())]);
                              const nuevos = tokens.filter(t => !base.has(t));
                              if (nuevos.length) {
                                setExtraErpIds(prev => [...prev, ...nuevos]);
                                setPreviewData(null);
                              }
                            });
                          }}
                          style={{ minWidth:'unset' }}
                        >
                          Pegar varios
                        </Button>
                      </div>
  
                      {extraErpIds.length > 0 && (
                        <div style={{ marginTop: 6 }}>
                          <div style={{ fontSize:12, color:'#666', marginBottom:4 }}>Pedidos ERP agregados:</div>
                          <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                            {extraErpIds.map((id, i) => (
                              <div key={i} className="pill">
                                <span style={{ fontWeight:600 }}>{id}</span>
                                <Button
                                  small
                                  className="red"
                                  style={{ minWidth:'unset', padding:'0 8px', height:22, lineHeight:'22px', marginLeft:6 }}
                                  onClick={() => { setExtraErpIds(prev => prev.filter((_, idx) => idx !== i)); setPreviewData(null); }}
                                  title="Quitar"
                                >
                                  ×
                                </Button>
                              </div>
                            ))}
                          </div>
  
                          <div style={{ display:'flex', gap:8, marginTop:10 }}>
                            <Button small onClick={buildPreviewConsolidated} disabled={previewLoading}>
                              {previewLoading ? 'Calculando…' : 'Previsualizar consolidado'}
                            </Button>
                            {previewData && (
                              <div style={{ alignSelf:'center', color:'#1b5e20', fontWeight:700 }}>
                                Consolidado listo ✓
                              </div>
                            )}
                          </div>
  
                          {previewData && <PreviewTabs items={previewData.items} originals={previewData.originals || {}} />}
                        </div>
                      )}
                    </div>
                  )}
  
                  <h6 style={{ marginBottom: '1rem', fontWeight: 'bold', marginTop: 12 }}>Adjuntar archivos</h6>
                  {!(saldoAFavor || payOnDelivery) && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                      <div>
                        <Button onClick={() => document.getElementById('file-voucher-multiple').click()} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <MdAttachFile /> COMPROBANTE(S) DE PAGO
                        </Button>
                        <input
                          id="file-voucher-multiple"
                          type="file"
                          accept="application/pdf,image/*"
                          multiple
                          style={{ display: 'none' }}
                          onChange={(e) => {
                            const selected = Array.from(e.target.files || []);
                            if (selected.length === 0) return;
                            setFiles((prev) => ({ ...prev, vouchers: [...(prev.vouchers || []), ...selected] }));
                            e.target.value = '';
                          }}
                        />
  
                        {voucherPreviews.length > 0 && (
                          <div style={{
                            marginTop: 10,
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                            gap: 10
                          }}>
                            {voucherPreviews.map((p, i) => {
                              const isImg = (p.type || '').startsWith('image/');
                              const isPdf = (p.type || '') === 'application/pdf';
                              return (
                                <div key={i} style={{
                                  border: '1px solid #e0e0e0',
                                  borderRadius: 8,
                                  padding: 8,
                                  background: '#fff'
                                }}>
                                  <div
                                    onClick={() => previewVoucherAt(i)}
                                    title="Ver vista previa"
                                    style={{
                                      cursor: 'zoom-in',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      background: '#fafafa',
                                      border: '1px dashed #ddd',
                                      borderRadius: 6,
                                      height: 110,
                                      overflow: 'hidden'
                                    }}
                                  >
                                    {isImg ? (
                                      <img
                                        src={p.url}
                                        alt={p.name}
                                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'cover' }}
                                      />
                                    ) : isPdf ? (
                                      <div style={{ fontSize: 12, textAlign: 'center', padding: 8 }}>
                                        <div style={{ fontWeight: 800, marginBottom: 6 }}>PDF</div>
                                        <div style={{
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          maxWidth: 120,
                                          margin: '0 auto',
                                          color: '#444'
                                        }}>
                                          {p.name}
                                        </div>
                                        <div style={{ fontSize: 11, color: '#777', marginTop: 2 }}>
                                          Click para ver
                                        </div>
                                      </div>
                                    ) : (
                                      <div style={{ fontSize: 12, textAlign: 'center', padding: 8 }}>
                                        <div style={{ fontWeight: 800, marginBottom: 6 }}>Archivo</div>
                                        <div style={{
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          maxWidth: 120,
                                          margin: '0 auto',
                                          color: '#444'
                                        }}>
                                          {p.name}
                                        </div>
                                        <div style={{ fontSize: 11, color: '#777', marginTop: 2 }}>
                                          Click para abrir
                                        </div>
                                      </div>
                                    )}
                                  </div>
  
                                  <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: 8,
                                    gap: 6
                                  }}>
                                    <div style={{
                                      flex: 1,
                                      fontSize: 12,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis'
                                    }}>
                                      {p.name}
                                    </div>
                                    <Button
                                      small
                                      className="red"
                                      style={{ minWidth:'unset', padding:'0 8px', height:24, lineHeight:'24px' }}
                                      onClick={() =>
                                        setFiles(prev => ({
                                          ...prev,
                                          vouchers: prev.vouchers.filter((_, idx) => idx !== i)
                                        }))
                                      }
                                      title="Quitar"
                                    >
                                      ×
                                    </Button>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
          
          )}
  
          <div style={{ display: 'none' }}>
            {pedidoInfo && (
              <div id="reprintContainer">
                <PedidoReprintView
                  onProps={{
                    numeroPedido: erpOrderId,
                    remision: pedidoInfo.remision,
                    cliente: pedidoInfo.cliente,
                    vendedor: pedidoInfo.agente,
                    comentarios: pedidoInfo.comentarios,
                    direccion: pedidoInfo.direccion,
                    fecha: pedidoInfo.fecha,
                    status: pedidoInfo.status,
                    subtotal: pedidoInfo.subtotal,
                    descuento: pedidoInfo.descuento || 0,
                    iva: pedidoInfo.iva,
                    total: pedidoInfo.total,
                    articulos: pedidoInfo.articulos,
                    colores: [],
                    usuario: JSON.parse(localStorage.getItem('user'))?.name || ''
                  }}
                />
              </div>
            )}
          </div>
  
          {createdOrders.length > 0 && (
            <div style={{ marginTop: '3rem' }}>
              <div
                style={{
                  marginBottom: '0.5rem',
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'flex-end',
                  gap: 20
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: 12, color: '#666' }}>Desde</label>
                  <input
                    type="date"
                    value={filterFrom}
                    onChange={(e) => setFilterFrom(e.target.value)}
                    style={{ padding: '6px 10px', border: '1px solid #ccc', borderRadius: 6 }}
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: 12, color: '#666' }}>Hasta</label>
                  <input
                    type="date"
                    value={filterTo}
                    onChange={(e) => setFilterTo(e.target.value)}
                    style={{ padding: '6px 10px', border: '1px solid #ccc', borderRadius: 6 }}
                  />
                </div>
  
                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 8,
                    flexWrap: 'wrap'
                  }}
                >
                  <Button small onClick={() => setQuickRange('hoy')} style={{ minWidth: 'unset' }}>
                    Hoy
                  </Button>
                  <Button small onClick={() => setQuickRange('ayer')} style={{ minWidth: 'unset' }}>
                    Ayer
                  </Button>
                  <Button small onClick={() => setQuickRange('7')} style={{ minWidth: 'unset' }}>
                    Últ. 7 días
                  </Button>
                  <Button small onClick={() => setQuickRange('mes')} style={{ minWidth: 'unset' }}>
                    Este mes
                  </Button>
                  <Button small className="grey" onClick={() => setQuickRange('clear')} style={{ minWidth: 'unset' }}>
                    Limpiar
                  </Button>
                </div>
  
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <Button small onClick={doRefresh} style={{ minWidth:'unset' }}>
                    {refreshing ? 'Actualizando…' : 'Actualizar'}
                  </Button>
                  <div style={{ color: '#555', fontSize: 'clamp(13px, 1.05vw, 16px)', fontWeight: 800 }}>
                    Mostrando: <b>{filteredOrders.length}</b> {filteredOrders.length === 1 ? 'turno' : 'turnos'}
                  </div>
                </div>
              </div>
  
              <p style={{ marginTop: 8, color:'#666', fontSize:12 }}>
                * Los turnos devueltos aparecen como <span style={{ padding:'1px 5px', background:'#fff3cd', border:'1px solid #f0e1a6', borderRadius:4 }}>Devuelto</span> y se ordenan por la fecha de devolución.
              </p>
  
              <h6 style={{ fontWeight: 'bold' }}>Mis turnos creados</h6>
              <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
                <thead>
                  <tr>
                    <th style={{ borderBottom: '1px solid #ccc', padding: '0.5rem' }}>Pedido</th>
                    <th style={{ borderBottom: '1px solid #ccc', padding: '0.5rem' }}>Cliente</th>
                    <th style={{ borderBottom: '1px solid #ccc', padding: '0.5rem' }}>Paquetería</th>
                    <th style={{ borderBottom: '1px solid #ccc', padding: '0.5rem' }}>Fecha</th>
                    <th style={{ borderBottom: '1px solid #ccc', padding: '0.5rem' }}>Estatus actual</th>
                    <th style={{ borderBottom: '1px solid #ccc', padding: '0.5rem' }}>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrders.map((order) => {
                    const isReturned = !!order.returned_at;
                    const reason = (order.return_reason || '').trim();
                    const d = new Date(isReturned ? order.returned_at : order.created_at);
  
                    const origRaw = (order.erp_order_id_original || order.erp_order_id_prev || '').trim();
                    const mainRaw = (order.erp_order_id || '').trim();
                    const showOrig = origRaw && origRaw !== mainRaw;
  
                    return (
                      <tr key={order.id} style={{ background: isReturned ? '#fffdf3' : undefined }}>
                        <td style={{ padding: '0.5rem' }}>
                          {order.erp_order_id}{' '}
                          {showOrig && (
                            <span
                              title="ERP original"
                              style={{
                                marginLeft: 6,
                                padding: '2px 6px',
                                background: '#e3f2fd',
                                border: '1px solid #90caf9',
                                borderRadius: 6,
                                fontSize: 11,
                                fontWeight: 700,
                                color: '#0d47a1'
                              }}
                            >
                              Original: {origRaw}
                            </span>
                          )}
                          {isReturned && (
                            <span
                              className="chip chip-warn"
                              title="Devuelto desde Cajas"
                              style={{ marginLeft: 6 }}
                            >
                              Devuelto
                            </span>
                          )}
                        </td>
  
                        <td style={{ padding: '0.5rem' }}>{order.customer_name}</td>
  
                        <td style={{ padding: '0.5rem' }}>
                          {order.carrier}
                          {order.invoice_required ? (
                            <span
                              style={{
                                marginLeft: 6,
                                padding: '2px 6px',
                                background: '#ffe0b2',
                                color: '#bf360c',
                                borderRadius: 6,
                                fontSize: 11
                              }}
                            >
                              Factura
                            </span>
                          ) : null}
                        </td>
  
                        <td style={{ padding: '0.5rem' }}>
                          {d.toLocaleString('es-MX')}
                          {isReturned && (
                            <>
                              <div style={{ fontSize: 11, color: '#8d6e00' }}>(fecha de devolución)</div>
                              {reason && (
                                <div
                                  style={{
                                    marginTop: 4,
                                    fontSize: 12,
                                    background: '#fff3cd',
                                    border: '1px solid #f0e1a6',
                                    color: '#705d00',
                                    borderRadius: 6,
                                    padding: '6px 8px',
                                    maxWidth: 420
                                  }}
                                >
                                  <b>Motivo:</b> {reason}
                                </div>
                              )}
                            </>
                          )}
                        </td>
  
                        <td style={{ padding: '0.5rem' }}>
                          <StatusPill status={order.status_visible || order.status || order.order_status} />
                        </td>
                        <td style={{ padding: '0.5rem', display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                          <Button
                            className="teal"
                            small
                            onClick={() => previewSavedOrder(order)}
                            style={{ minWidth: 'unset', padding: '0 10px' }}
                            title="Ver pedido(s) consolidado(s)"
                            disabled={loadingPreviewSaved}
                          >
                             <span role="img" aria-label="ver">👁️</span>
                            
                          </Button>
  
                          {isReturned && (
                            <Button
                              className="orange"
                              small
                              onClick={() => prefillFromOrder(order)}
                              style={{ minWidth: 'unset', padding: '0 10px' }}
                              title="Editar turno (devuelto)"
                            >
                              <span role="img" aria-label="Editar">✏️</span>
                              
                            </Button>
                          )}
  
                          {isReturned && (
                            <Button
                              small
                              onClick={() => verDevolucion(order)}
                              style={{ minWidth: 'unset', padding: '0 10px', display: 'flex', alignItems: 'center', gap: 4 }}
                              title="Ver detalle de devolución"
                            >
                              <MdHistoryEdu size={16} />
                              Detalle
                            </Button>
                          )}
  
                          <Button
                            className="blue"
                            small
                            onClick={() => mostrarLinkSeguimiento(order.id)}
                            style={{ minWidth: 'unset', padding: '0 10px' }}
                            title="Link de seguimiento"
                          >
                            <span role="img" aria-label="Link">🔗</span>
                            
                          </Button>
                          <Button
                            className="grey"
                            small
                            onClick={() => regenerarLinkSeguimiento(order.id)}
                            style={{ minWidth: 'unset', padding: '0 10px' }}
                            title="Rotar enlace"
                          >
                            <span role="img" aria-label="Rotar">♻️</span>
                            
                          </Button>
                          <Button
                            className="red"
                            small
                            onClick={() => eliminarTurno(order.id)}
                            style={{ minWidth: 'unset', padding: '0 10px' }}
                            title="Eliminar turno"
                          >
                            <span role="img" aria-label="Eliminar">🗑️</span>
                            
                          
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    ),
    document.body
  );
  
};

export default ModalRemoteOrders;
